import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
    providedIn: 'root'
})
export class MaintenanceService {
    private _inMaintenance = new BehaviorSubject<boolean | null>(null);
    private _iKnowWhatImDoing = new BehaviorSubject<boolean>(false);

    constructor() {}

    set inMaintenance(inMaintenance: boolean) {
        this._inMaintenance.next(inMaintenance);
    }

    get inMaintenance(): boolean {
        if (this._iKnowWhatImDoing.value) return false;
        return this._inMaintenance.value;
    }

    get inMaintenance$(): Observable<boolean> {
        if (this._iKnowWhatImDoing.value) return of(false);
        return this._inMaintenance.asObservable();
    }

    set iKnowWhatImDoing(bypass: boolean) {
        this._iKnowWhatImDoing.next(bypass);
    }
}
